var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corporateCultureBox"},[_c('aboutBannerVue',{attrs:{"tabIndex":"6"}}),_c('TypicalAchievement',{attrs:{"show-tabs":true,"show-all-tab":true,"show-sidebar":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }